class SliderProduct extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      slider_element: this
    };
    this.init();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }

  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }

  onSectionLoad(event) {
    filterShopifyEvent(event, this, () => this.initSlider());
  }
  onSectionSelect(event) {
    filterShopifyEvent(event, this, this.initSlider.bind(this));
  }
  onSectionDeselect(event) {
    filterShopifyEvent(event, this, this.initSlider.bind(this));
  }

  init() {
    if (Shopify && Shopify.designMode) {
      this.initSlider();
    }
    setTimeout(() => {
      this.initSlider();
    });
    window.addEventListener('resize', this.handleWindowResize.bind(this));
  }

  handleWindowResize() {
    const tablet = window.matchMedia('(min-width: 750px)');
    if (tablet.matches) {
      if (!this.swiper) {
        this.initSlider();
      }
    } else {
      if (this.swiper) {
        // this.destroySlider();
      }
    }
  }

  initSlider() {
    const parent = this.closest('section.shopify-section');
    const mobile = window.matchMedia('(min-width: 0px) and (max-width: 749px)');
    const tablet = window.matchMedia('(min-width: 750px)');
    if(tablet.matches) {
        var swiper = new Swiper(this.elements.slider_element, {
            slidesPerView: 2,
            spaceBetween: 8,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
              nextEl: parent && parent.querySelector(".swiper-button-next"),
              prevEl: parent && parent.querySelector(".swiper-button-prev"),
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 16,
                },
                1400: {
                  slidesPerView: 4,
                  spaceBetween: 32,
              },
            },
        });
    }
    if(mobile.matches) {
        var swiper2 = new Swiper( this.elements.slider_element, {
            slidesPerView: 2,
            grid: {
                rows: 2,
            },
            spaceBetween: 8,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
              nextEl: parent && parent.querySelector(".swiper-button-next"),
              prevEl: parent && parent.querySelector(".swiper-button-prev"),
            }

        });
    }
  }
}

customElements.define('slider-product', SliderProduct);